import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/shared/Sidebar';
import TopBar from '../components/shared/TopBar';
import { LayoutDashboard, Home, CalendarDays, Users, MessageSquare, CreditCard, UserCircle, Wallet } from 'lucide-react';

const groups = [
  { label: 'Operations', items: [
    { to: '/host/dashboard', label: 'Dashboard', icon: LayoutDashboard, end: true },
    { to: '/host/properties', label: 'Properties', icon: Home },
    { to: '/host/bookings', label: 'Bookings', icon: CalendarDays },
    { to: '/host/customers', label: 'Customers', icon: Users },
    { to: '/host/messages', label: 'Messages', icon: MessageSquare },
  ]},
  { label: 'Payments', items: [
    { to: '/host/payments', label: 'Payments & Payouts', icon: CreditCard },
    { to: '/host/payout-setup', label: 'Payout setup', icon: Wallet },
  ]},
  { label: 'Account', items: [
    { to: '/host/profile', label: 'Profile', icon: UserCircle },
  ]},
];

export default function HostLayout() {
  return (
    <div className="min-h-screen bg-slate-50/60 flex">
      <Sidebar brand="StayEasy" badge="Host Console" groups={groups} />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        <main className="flex-1 px-6 md:px-8 py-7 animate-fade-in">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
